import React from 'react';
import BaseIcon from './BaseIcon.js';

const IconDecrement = function ({ size }) {
  return (
    <BaseIcon viewBox="0 0 32 32" size={size}>
      <g>
        <rect fill="none" height="32" width="32" />
      </g>
      <g>
        <polygon points="2.002,10 16.001,24 30.002,10  " />
      </g>
    </BaseIcon>
  );
}

export default IconDecrement;


